/**
 * Entry point.
 */
import { Application, ControllerServiceProvider } from '@cherrypulp/trunk';
import AxiosServiceProvider from "./providers/AxiosServiceProvider";
import VueServiceProvider from "./providers/VueServiceProvider";

const app = new Application();

app.register(new ControllerServiceProvider(app));
app.register(new AxiosServiceProvider());
app.register(new VueServiceProvider());

document.addEventListener('DOMContentLoaded', () => app.boot());
